import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import React from 'react'

export const BottomBlock = () => {
  const staticBlock = useCmsBlock({
    id: CMS_BLOCK.PPQ_PRODUCT_RESULT_BOTTOM,
    isLazy: false
  })

  if (!staticBlock.content) return null

  return (
    <div
      className='info-section _bottom'
      dangerouslySetInnerHTML={{
        __html: staticBlock.content
      }}
    />
  )
}
